import React, { useEffect, useState } from "react";
import Pdf from "../../../assets/img/pdf.svg";

const IMAGE_EXTENSIONS = ["jpeg", "jpg", "png", "webp", "heic", "heif"];

export const getClaimDocumentUrls = (multipleUrls, fallbackUrl) => {
  const urls = Array.isArray(multipleUrls) ? multipleUrls.filter(Boolean) : [];
  return urls.length > 0 ? urls : fallbackUrl ? [fallbackUrl] : [];
};

const getFileExtension = (url) => {
  if (!url || typeof url !== "string") return "";
  const cleanUrl = url.split("?")[0].split("#")[0];
  return cleanUrl.substring(cleanUrl.lastIndexOf(".") + 1).toLowerCase();
};

export const ClaimDocumentPreview = ({ url }) => {
  const extension = getFileExtension(url);

  if (IMAGE_EXTENSIONS.includes(extension)) {
    return (
      <img
        src={url}
        className="claim-document-image zoom"
        onMouseMove={(event) => {
          const rect = event.currentTarget.getBoundingClientRect();
          const x = ((event.clientX - rect.left) / rect.width) * 100;
          const y = ((event.clientY - rect.top) / rect.height) * 100;
          event.currentTarget.style.transformOrigin = `${x}% ${y}%`;
        }}
        onMouseLeave={(event) => {
          event.currentTarget.style.transformOrigin = "center";
        }}
      />
    );
  }

  if (extension === "pdf") {
    return <img src={Pdf} className="claim-document-pdf" />;
  }

  return <span className="claim-document-unsupported">Unsupported file</span>;
};

const ClaimDocumentSlider = ({ documents, emptyText }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const documentKey = (documents || []).join("|");

  useEffect(() => {
    setActiveIndex(0);
  }, [documentKey]);

  if (!documents || documents.length === 0) {
    return <p>{emptyText}</p>;
  }

  const currentUrl = documents[activeIndex] || documents[0];
  const hasMultipleDocuments = documents.length > 1;

  const moveDocument = (direction) => {
    setActiveIndex((currentIndex) =>
      (currentIndex + direction + documents.length) % documents.length,
    );
  };

  return (
    <div className="claim-document-slider">
      <div className="claim-document-frame">
        {hasMultipleDocuments && (
          <button
            type="button"
            className="claim-document-arrow claim-document-arrow-left"
            onClick={() => moveDocument(-1)}
          >
            {"<"}
          </button>
        )}
        <a href={currentUrl} target="_blank">
          <ClaimDocumentPreview url={currentUrl} />
        </a>
        {hasMultipleDocuments && (
          <button
            type="button"
            className="claim-document-arrow claim-document-arrow-right"
            onClick={() => moveDocument(1)}
          >
            {">"}
          </button>
        )}
      </div>
      {hasMultipleDocuments && (
        <div className="claim-document-count">
          {activeIndex + 1} / {documents.length}
        </div>
      )}
    </div>
  );
};

export default ClaimDocumentSlider;
